import Konva from "konva";
import { useDevOverlayStore } from "../../stores/dev-overlay-store";
import { useScheduleStore } from "../../stores/schedule-store";
import { useMetadataBuilderStore } from "../../stores/metadata-builder-store";

export function attachDevOverlay(stage: Konva.Stage) {
  const layer = new Konva.Layer();
  const node = new Konva.Image({ image: undefined, draggable: true });
  const transformer = new Konva.Transformer({
    nodes: [], keepRatio: true, flipEnabled: false,
    enabledAnchors: ["top-left", "top-right", "bottom-left", "bottom-right"],
  });
  layer.add(node);
  layer.add(transformer);
  stage.add(layer);

  let selected = true;
  let currentImage: HTMLImageElement | undefined;
  const select = (next: boolean) => {
    selected = next;
    const { locked } = useDevOverlayStore.getState();
    const shouldShowHandles = selected && node.visible() && !locked;
    transformer.nodes(shouldShowHandles ? [node] : []);
  };
  const onPointerDown = (event: Konva.KonvaEventObject<PointerEvent>) => {
    if (transformer.isAncestorOf(event.target)) return;
    select(event.target === node);
  };
  const onOutsidePointerDown = (event: PointerEvent) => {
    if (event.target instanceof Node && !stage.container().contains(event.target)) select(false);
  };
  stage.on("pointerdown", onPointerDown);
  document.addEventListener("pointerdown", onOutsidePointerDown);

  const update = () => {
    const { overlay, opacity, locked, hidden } = useDevOverlayStore.getState();
    const { developerMode } = useScheduleStore.getState();
    const builderActive = useMetadataBuilderStore.getState().active;
    const enabled = builderActive || developerMode;
    const visible = enabled && !!overlay && !hidden;
    node.visible(visible);
    node.listening(visible && !locked);
    node.draggable(visible && !locked);
    if (overlay?.image !== currentImage) {
      currentImage = overlay?.image;
      selected = true;
    }
    select(selected);
    if (overlay) {
      node.setAttrs({ image: overlay.image, ...overlay.transform, opacity: opacity / 100 });
      transformer.forceUpdate();
    }
  };
  node.on("dragend transformend", () => {
    useDevOverlayStore.getState().setTransform({
      x: node.x(), y: node.y(), width: node.width(), height: node.height(),
      scaleX: node.scaleX(), scaleY: node.scaleY(), rotation: node.rotation(),
    });
  });
  update();
  const unsubscribeOverlay = useDevOverlayStore.subscribe(update);
  const unsubscribeBuilder = useMetadataBuilderStore.subscribe((state, previous) => {
    if (state.active !== previous.active) update();
  });
  const unsubscribeSchedule = useScheduleStore.subscribe((state, previous) => {
    if (state.developerMode !== previous.developerMode) update();
  });
  return () => {
    node.off("dragend transformend");
    unsubscribeOverlay();
    unsubscribeBuilder();
    unsubscribeSchedule();
    stage.off("pointerdown", onPointerDown);
    document.removeEventListener("pointerdown", onOutsidePointerDown);
  };
}
